import { useStore } from '@/store';

export function t(ko, en) {
  const store = useStore();
  return store.userLanguage === 'en' ? en : ko;
}
